import ReactGA from 'react-ga';

let isInitialized = false;

export const initGA = (key) => {
  if (!isInitialized && key && !window.location.href.includes('localhost')) {
    ReactGA.initialize(key);
    isInitialized = true;
  }
};

export const trackPageView = (path) => {
  if (!isInitialized) return;
  ReactGA.pageview(path);
};

export const trackEvent = (category, action) => {
  if (!isInitialized) return;

  console.log('htting actual analytics', category, action);

  ReactGA.event(category, action);
};
